import { apiRequest } from "./client";

/** Playbook presets (Sprint 9, Part 89 §89.4). */

export const playbooksApi = {
  async list() {
    const res = await apiRequest("/api/playbooks");
    return res.items || [];
  },

  async find(id) {
    return apiRequest(`/api/playbooks/${id}`);
  },
};
